<template>
    <main class="main-content">
        <slider></slider>

        <section class="section">
            <div class="content has-text-centered">
                <h3 v-html="$t('homepage.section1.title')"></h3>
                <p v-t="'homepage.section1.content'"></p>
            </div>
        </section>

        <parallax-section background="/assets/img/new-way-drinking.jpg?id=45124741">
            <h2 class="section-title has-text-centered" v-html="$t('homepage.section2.title')"></h2>
        </parallax-section>

        <section class="section">
            <div class="content has-text-centered">
                <p v-t="'homepage.section2.content'"></p>
            </div>
            <div class="columns my-3 is-multiline is-mobile">
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/waste-icon.svg?id=45124741" class="icon"></object>
                    <p v-html="$t('homepage.section2.advantages.1')"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/eco-icon.svg?id=45124741" class="icon"></object>
                    <p v-html="$t('homepage.section2.advantages.2')"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/sustanailable-icon.svg?id=45124741" class="icon"></object>
                    <p v-html="$t('homepage.section2.advantages.3')"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/co2-icon.svg?id=45124741" class="icon"></object>
                    <p v-html="$t('homepage.section2.advantages.4')"></p>
                </div>
            </div>
            <div class="content has-text-centered">
                <router-link :to="{ name: $i18n.locale+'.be_smart' }" class="button" v-t="'homepage.section2.cta'"></router-link>
            </div>
        </section>

        <parallax-section id="smart-business" background="/assets/img/smart-business.jpg?id=45124741">
            <div class="has-text-centered">
                <h2 class="section-title" v-t="'homepage.section3.title'"></h2>
                <h3 class="section-subtitle" v-t="'homepage.section3.subtitle'"></h3>
            </div>
        </parallax-section>

        <section class="section">
            <div class="content has-text-centered">
                <h3 class="mb-3" v-html="$t('homepage.section3.content')"></h3>
            </div>
            <div class="columns is-multiline is-mobile my-3">
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/hq-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'homepage.section3.advantages.1'"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/clock-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'homepage.section3.advantages.2'"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/saving-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'homepage.section3.advantages.3'"></p>
                </div>
                <div class="column is-3-tablet is-6-mobile has-text-centered">
                    <object data="/assets/img/barel-icon.svg?id=45124741" class="icon"></object>
                    <p v-t="'homepage.section3.advantages.4'"></p>
                </div>
            </div>
            <div class="content has-text-centered">
                <router-link :to="packageRoute" class="button" v-t="'homepage.section3.cta'"></router-link>
            </div>
        </section>

        <parallax-section background="/assets/img/heart-of-veneto.jpg?id=45124741"
                          :caption="$t('homepage.section4.caption')">
            <h2 class="section-title has-text-centered" v-t="'homepage.section4.title'"></h2>
        </parallax-section>

        <section class="section">
            <div class="content has-text-centered">
                <p class="mb-3" v-t="'homepage.section4.content'"></p>
                <router-link :to="{ name: $i18n.locale+'.about' }" class="button" v-t="'homepage.section4.cta'"></router-link>
            </div>
        </section>

        <parallax-section background="/assets/img/quality-of-wine.jpg?id=45124741">
            <h2 class="section-title has-text-centered" v-t="'homepage.section5.title'"></h2>
        </parallax-section>

        <section class="section">
            <div class="content has-text-centered">
                <p class="mb-3" v-t="'homepage.section5.content'"></p>
            </div>
        </section>

        <collection-router></collection-router>
    </main>
</template>
<script>
    import Slider from './../components/Slider'
    import ParallaxSection from './../components/ParallaxSection'
    import CollectionRouter from './../components/CollectionRouter'

    export default {
        components: {
            Slider,
            ParallaxSection,
            CollectionRouter
        },
        computed: {
            packageRoute() {
                return {
                    name: ( this.$i18n.locale === 'it' || this.$store.state.viewSteelKeg ) ? this.$i18n.locale+'.steelKeg' : this.$i18n.locale+'.keyKeg'
                }
            }
        },
        metaInfo() {
            return {
                title: this.$t('seo.homepage.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.homepage.title')},
                    {name: 'description', content: this.$t('seo.homepage.description')}
                ]
            }
        }
    }
</script>